/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import { API } from "aws-amplify";
import { createRide } from "../../graphql/mutations";
import { listRides } from "../../graphql/queries";
import { onCreateRide } from "../../graphql/subscriptions";

const state = {
  rides: [],
  isSubscribed: false,
};

const getters = {};

const actions = {
  
  async loadRides({ commit }) {
    commit("setIsLoading", true, { root: true });
    const response = await API.graphql({
      query: listRides,
    });
    commit("setRides", response.data.listRides.items);

    // Subscribe to creation events

    if (!state.isSubscribed) {
      await API.graphql({ query: onCreateRide }).subscribe({
        next: (eventData) => {
          let ride = eventData.value.data.onCreateRide;
          commit("addRide", ride);
        },
      });
      commit("setIsSubscribed", true);
    }

    commit("setIsLoading", false, { root: true });
  },

  async createRide({ commit }, ride) {
    commit("setIsLoading", true, { root: true });
    await API.graphql({
      query: createRide,
      variables: { input: ride },
    });
    commit("setIsLoading", false, { root: true });
  },

};

const mutations = {
  setRides(state, rides) {
    state.rides = rides;
  },
  addRide(state, ride) {
    if (state.rides?.some((item) => item.id === ride.id)) return; // avoid duplications
    state.rides.push(ride);
  },
  setIsSubscribed(state, isSubscribed) {
    state.isSubscribed = isSubscribed;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
